import { Expose, Type, instanceToPlain, plainToInstance } from '@infrastructure/domain';
import { formatISODate } from '@infrastructure/dates';

import type * as Types from '../../interfaces/xingOne';

import { SlugOrID } from '../scalars';

export type ReportX1 = Types.ErecruitingSourcingServiceBriefingReport;
export type ReportCollectionX1 = Types.ErecruitingSourcingServiceBriefingReportsCollectionResponse;

export class Report implements ReportX1 {

  static fromData(data: Subset<ReportX1>): Report {
    return plainToInstance(Report, data);
  }

  static fromDataCollection(collection: Subset<ReportX1>[]): Report[] {
    return collection.map((data) => Report.fromData(data));
  }

  toData(): Record<string, any> {
    const data = instanceToPlain<Report>(this);

    return {
      ...data,
      reportDateStart: formatISODate(this.reportDateStart),
      reportDateEnd: formatISODate(this.reportDateEnd),
      sentAt: this.sentAt.toISOString(),
      createdAt: this.createdAt.toISOString(),
      updatedAt: this.updatedAt.toISOString(),
    }
  }

  @Expose()
  id: SlugOrID;

  @Expose()
  briefingId: SlugOrID;

  @Expose()
  projectId: SlugOrID;

  @Expose()
  consultantNotes?: Types.Maybe<string>;

  @Expose()
  nextStepsNotes?: Types.Maybe<string>;

  @Expose()
  read: boolean;

  @Expose() @Type(() => Date)
  reportDateStart?: Types.Maybe<Date>;

  @Expose() @Type(() => Date)
  reportDateEnd?: Types.Maybe<Date>;

  @Expose() @Type(() => Date)
  sentAt: Types.Maybe<Date>;

  @Expose() @Type(() => Date)
  createdAt: Types.Maybe<Date>;

  @Expose() @Type(() => Date)
  updatedAt: Types.Maybe<Date>;

  @Expose() @Type(() => Date)
  resentAt: Types.Maybe<Types.Maybe<Date>[]>;
}

export class ReportCollection implements ReportCollectionX1 {

  static fromData(data: Subset<ReportCollectionX1>): ReportCollection {
    const instance = plainToInstance(ReportCollection, data);
    instance.collection = Report.fromDataCollection(data.collection);

    return instance;
  }

  @Expose()
  total: number;

  @Expose() @Type(() => Date)
  collection: Report[];
}
